
  (function () {
    var bars = document.querySelectorAll('.kaching-bundles__bar');
    var btns = document.querySelectorAll('.btn-edition');
    var cta = document.getElementById('main-lp7_checkout');
    var svg = cta.querySelector('svg');
    var outOfStock = document.querySelector('.kaching-bundles__out-of-stock');
    outOfStock.style.display = 'none';

    // Image sources per edition
    var images = {
      essential:
        'https://assets.checkoutchamp.com/0d1b5780-b1a0-401c-a559-e3327e340635/1778775684812_WhatsApp_Image_2026_05_14_at_21.15.34.webp',
      ultra:
        'https://assets.checkoutchamp.com/0d1b5780-b1a0-401c-a559-e3327e340635/1778775782024_WhatsApp_Image_2026_05_14_at_21.15.18.jpeg',
    };

    // Update main image and thumbnail
    function updateImages(edition) {
      var src = images[edition];

      // Main product image
      var mainImg = document.getElementById('cc-id-Ibt5gj3cIJnE');
      if (mainImg) mainImg.src = src;

      // Thumbnail
      var thumb = document.querySelector('.Thumbnail-template--27042052473171__main_product_dynamic_BQV8rT-1');
      if (thumb) thumb.src = src;
    }

    bars.forEach(function (bar, i) {
      if (i >= 3) bar.style.display = 'none';
    });

    btns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var edition = btn.classList.contains('btn-edition-2') ? 'ultra' : 'essential';
        btns.forEach(function (b) {
          b.classList.remove('active');
        });
        btn.classList.add('active');

        document.getElementById('model-name').textContent =
          edition === 'essential' ? 'Essential Edition' : 'Ultra Edition';

        bars.forEach(function (bar, i) {
          bar.style.display = (edition === 'essential' ? i < 3 : i >= 3) ? 'block' : 'none';
        });

        var startIndex = edition === 'essential' ? 2 : 3;
        var firstBar = bars[startIndex];
        if (firstBar) {
          var radio = firstBar.querySelector('input[type="radio"]');
          if (radio) radio.click();
        }

        if (edition === 'ultra') {
          cta.childNodes[0].textContent = 'Sold Out';
          svg.style.display = 'none';
          cta.classList.add('sold-out-btn');
          outOfStock.style.display = 'block';
        } else {
          cta.childNodes[0].textContent = 'Get Yours Now';
          svg.style.display = 'block';
          cta.classList.remove('sold-out-btn');
          outOfStock.style.display = 'none';
        }

        // Update images based on selected edition
        updateImages(edition);
      });
    });
  })();

  (function () {
    var orderBtn = document.querySelector('.main-lp7_checkout');
    var bundle_radio = document.querySelectorAll('.kaching-bundles__bar input[type="radio"]');
    function findVariant() {
      const selectedBundleRadio = document.querySelector('.kaching-bundles__bar input[type="radio"]:checked');
      const mainVariantId = selectedBundleRadio
        ? parseInt(selectedBundleRadio.value, 10)
        : parseInt(selectedBundleRadio.value, 10);
      return mainVariantId;
    }
    console.log(findVariant());
    if (!orderBtn) {
      return;
    }
    setTimeout(() => {
      var fv = findVariant();
      if (fv) {
        setTimeout(() => {
          orderBtn.setAttribute('href', '/cart/' + fv + ':1');
        }, 500);
      } else {
        setTimeout(() => {
          orderBtn.setAttribute('href', '#');
        }, 500);
      }
      scheduleStage();
    }, 1000);
    // ——— cart pre-staging: keep the Shopify cart synced with the current selection in the background,
    // so the ORDER NOW click can skip the clear+add round-trips and hand off to checkout immediately (esp. mobile) ———
    var stagedId = null,
      stagingPromise = null,
      stageTimer = null;
    function stageCart() {
      var sid = findVariant();
      stagingPromise = (async function () {
        try {
          await fetch('/cart/clear.js', { method: 'POST' });
          var r = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: sid, quantity: 1 }] }),
          });
          stagedId = r.ok ? sid : null;
        } catch (e) {
          stagedId = null;
        }
      })();
      return stagingPromise;
    }
    function scheduleStage() {
      stagedId = null;
      clearTimeout(stageTimer);
      stageTimer = setTimeout(stageCart, 350);
    }

    function update(id) {
      var fv = findVariant();
      if (fv) {
        setTimeout(() => {
          orderBtn.setAttribute('href', '/cart/' + fv + ':1');
        }, 500);
      } else {
        setTimeout(() => {
          orderBtn.setAttribute('href', '#');
        }, 500);
      }
      scheduleStage();
    }
    function updatevariant(id) {
      var fv = id;
      if (fv) {
        orderBtn.setAttribute('href', '/cart/' + fv + ':1');
      } else {
        orderBtn.setAttribute('href', '#');
      }
      scheduleStage();
    }
    orderBtn.addEventListener('click', async function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var fv = findVariant();

      var original = orderBtn.innerHTML;
      orderBtn.classList.add('is-loading');
      orderBtn.textContent = 'Loading...';
      try {
        var want = findVariant();
        // fast path: if the cart is already pre-staged with this exact variant, skip the clear+add round-trips
        if (stagedId !== want && stagingPromise) {
          try {
            await stagingPromise;
          } catch (e) {}
        }
        if (stagedId !== want) {
          // fallback (single-product funnel: only the selected bundle should be in cart)
          await fetch('/cart/clear.js', { method: 'POST' });
          var res = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: want, quantity: 1 }] }),
          });
          if (!res.ok) {
            var result = await res.json();
            throw new Error(result.description || 'Failed to add item to cart');
          }
          stagedId = want;
        }
        // hand off to Lasso checkout (skips Shopify cart)
        if (typeof window.proceedToCheckout === 'function') {
          window.proceedToCheckout();
        } else {
          window.location.href = '/checkout';
        }
      } catch (err) {
        console.error('Checkout error:', err);
        orderBtn.classList.remove('is-loading');
        orderBtn.innerHTML = original;
        alert(err.message || 'Something went wrong. Please try again.');
      }
    });
    bundle_radio.forEach((radio, index) => {
      radio.addEventListener('change', function () {
        if (this.checked) {
          updatevariant(this.value);
        }
      });
    });
    update();
  })();
(function () {
  var bars = document.querySelectorAll('.kaching-bundles__bar');
  var btns = document.querySelectorAll('.btn-edition');
  var cta = document.getElementById('main-lp7_checkout');
  var svg = cta.querySelector('svg');
  var outOfStock = document.querySelector('.kaching-bundles__out-of-stock');
  if (outOfStock) outOfStock.style.display = 'none';

  function updateImages(src) {
    if (!src) return;
    var galleryList = document.getElementById('Slider-Gallery-template--27042052473171__main_product_dynamic_BQV8rT');
    if (!galleryList) return;
    var slides = galleryList.querySelectorAll('li.product__media-item');
    if (slides[0]) {
      var img = slides[0].querySelector('img');
      if (img) img.src = src;
      slides.forEach(function (li) { li.classList.remove('is-active'); });
      slides[0].classList.add('is-active');
    }
  }

  var moreToggle = document.getElementById('ap-more-toggle');

  // Split bars: those NOT inside .extra_variants. First 3 = Essential, next 3 = Ultra.
  var nonExtraBars = [];
  bars.forEach(function (bar) {
    if (!bar.closest('.extra_variants')) nonExtraBars.push(bar);
  });
  var essentialBars = nonExtraBars.slice(0, 3);
  var ultraBars = nonExtraBars.slice(3, 6);

  var extraVariantWrappers = document.querySelectorAll('.extra_variants');

  function selectBar(bar) {
    bars.forEach(function (b) { b.classList.remove('kaching-bundles__bar--selected'); });
    bar.classList.add('kaching-bundles__bar--selected');
    var r = bar.querySelector('input[type="radio"]');
    if (r) {
      r.checked = true;
      r.dispatchEvent(new Event('change', { bubbles: true }));
    }
    updateImages(bar.dataset.variantImg);
  }

  cta.addEventListener('click', function () {
    var selectedBar = document.querySelector('.kaching-bundles__bar--selected');
    if (selectedBar) {
      var r = selectedBar.querySelector('input[type="radio"]');
      if (r && r.value) r.checked = true;
    }
  }, true);

  bars.forEach(function (bar) {
    bar.addEventListener('click', function () { selectBar(bar); });
  });

  function setMoreToggleState(open) {
    if (!moreToggle) return;
    moreToggle.classList.toggle('is-open', open);
    var iconCircle = moreToggle.querySelector('.ap-more-icon-circle');
    var label = moreToggle.querySelector('.ap-more-label');
    if (iconCircle) iconCircle.textContent = open ? '−' : '+';
    if (label) label.textContent = open ? 'Show Less' : 'Need More? View More Options';
  }

  // INIT: Essential edition, extra_variants hidden, Ultra hidden, toggle closed
  extraVariantWrappers.forEach(function (w) { w.style.display = 'none'; });
  ultraBars.forEach(function (b) { if (b) b.style.display = 'none'; });
  setMoreToggleState(false);
  if (essentialBars[2]) selectBar(essentialBars[2]);

  // Toggle: show/hide extra_variants (Essential edition only)
  if (moreToggle) {
    moreToggle.addEventListener('click', function () {
      var isOpen = moreToggle.classList.contains('is-open');
      if (isOpen) {
        var anyExtraSelected = false;
        extraVariantWrappers.forEach(function (w) {
          var r = w.querySelector('input[type="radio"]');
          if (r && r.checked) anyExtraSelected = true;
        });
        if (anyExtraSelected && essentialBars[2]) selectBar(essentialBars[2]);
        extraVariantWrappers.forEach(function (w) { w.style.display = 'none'; });
        setMoreToggleState(false);
      } else {
        extraVariantWrappers.forEach(function (w) { w.style.display = 'block'; });
        setMoreToggleState(true);
      }
    });
  }

  btns.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var isUltra = btn.classList.contains('btn-edition-2');
      btns.forEach(function (b) { b.classList.remove('active'); });
      btn.classList.add('active');

      var modelName = document.getElementById('model-name');
      if (modelName) modelName.textContent = isUltra ? 'Ultra Edition' : 'Essential Edition';

      if (isUltra) {
        essentialBars.forEach(function (b) { if (b) b.style.display = 'none'; });
        extraVariantWrappers.forEach(function (w) { w.style.display = 'none'; });
        if (moreToggle) moreToggle.style.display = 'none';
        ultraBars.forEach(function (b) { if (b) b.style.display = 'block'; });
        if (ultraBars[0]) selectBar(ultraBars[0]);
      } else {
        ultraBars.forEach(function (b) { if (b) b.style.display = 'none'; });
        essentialBars.forEach(function (b) { if (b) b.style.display = 'block'; });
        extraVariantWrappers.forEach(function (w) { w.style.display = 'none'; });
        if (moreToggle) { moreToggle.style.display = ''; setMoreToggleState(false); }
        if (essentialBars[2]) selectBar(essentialBars[2]);
      }
    });
  });
})();

(function () {
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('#ap-more-toggle');
    if (!toggle) return;
    var willOpen = !toggle.classList.contains('is-open');
    document.querySelectorAll('.extra_variants').forEach(function (wrap) {
      wrap.style.setProperty('display', willOpen ? 'block' : 'none', 'important');
      wrap.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        bar.style.setProperty('display', willOpen ? 'block' : 'none', 'important');
      });
    });
    toggle.classList.toggle('is-open', willOpen);
    var icon = toggle.querySelector('.ap-more-icon-circle');
    var label = toggle.querySelector('.ap-more-label');
    if (icon) icon.textContent = willOpen ? '−' : '+';
    if (label) label.textContent = willOpen ? 'Show Less' : 'Need More? View More Options';
  });

  function hideExtras() {
    var extras = document.querySelectorAll('.extra_variants');
    if (!extras.length) return false;
    extras.forEach(function (wrap) {
      wrap.style.setProperty('display', 'none', 'important');
      wrap.querySelectorAll('.kaching-bundles__bar').forEach(function (bar) {
        bar.style.setProperty('display', 'none', 'important');
      });
    });
    return true;
  }

  if (!hideExtras()) {
    var observer = new MutationObserver(function () {
      if (hideExtras()) observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }
})();